export default defineNuxtRouteMiddleware(async (to, from) => {
    const { loggedIn, fetch: fetchSessionIfNeeded } = useUserSession();

    const publicPages = ['/login', '/about', '/'];
    const isPublicPage = publicPages.includes(to.path);

    const authRequired = !isPublicPage && to.meta.requiresAuth !== false;

    if (!loggedIn.value && (authRequired || to.path === '/')) {
        console.log('Not logged in, auth required or going to login page');
        await fetchSessionIfNeeded();
    }

    // Case 1: Route requires auth, but user is not logged in
    if (authRequired && !loggedIn.value) {
        console.debug('Auth required, not logged in...');
        return navigateTo({
            path: '/',
            query: { redirect: to.fullPath },
        });
    }

    // Case 2: User is logged in, but trying to access the login page
    if (loggedIn.value && to.path === '/') {
        console.log('User is logged in, but trying to access the login page...');
        const redirectUrl = (from.query.redirect as string) || '/dashboard';
        return navigateTo(redirectUrl);
    }

    return; // Allow navigation
});
